import React, { useState } from 'react';
import Input from 'src/components/Form/Input';
import SaveIcn from 'src/assets/images/common/green-tick-v2.svg';
import EditIcn from 'src/assets/images/common/edit-v2.svg';
import CloseIcn from 'src/assets/images/common/close.svg';
import DeleteIcn from 'src/assets/images/common/delete-v2.svg';
import { formatZeroIndexCharAsCapitalize } from 'src/utils/custom-formatters';
import { isExecutive } from 'src/views/pages/targetting/utils';

export default function SaveInput({editable = false, saveText = '', setSaveText = () => {}, applyAction = () => {}, savedItem = {}, deleteAction = () => {}, onSelectSaveAction = () => {}, createMasterSearch = false, updateMasterSearch = false }) {

  const [updateItem, setSaveItem] = useState(savedItem || {})
  const [loadingAction, setLoadingAction] = useState('');

  const [editKeyword, setEditKeyword] = useState(false)
  const selectedProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'))
  const currentUser= JSON.parse(localStorage.getItem('User'))
  const isExecutiveUser = isExecutive(selectedProfile?.accessLevel)
  const isCreator = savedItem?.createdBy == currentUser?.email
  const canShowEditDelete = !isExecutiveUser || (isExecutiveUser && isCreator)

  return (
    <section className={`d-flex flex-column gap-10 w-100 ${createMasterSearch?.loading ? 'disabled' : ''}`}>
      {editable ? (
        <>
          {!editKeyword ? <section className='d-flex align-items-center justify-content-between f-14 f-w-400 px-4 gap-10 l-20'>
            <p className='cursor-pointer' onClick={() => onSelectSaveAction(updateItem)}> {savedItem?.name} </p>
            {canShowEditDelete ? (
              <span className='d-flex gap-10'>
                <img src={EditIcn} alt='edit_keywrd' className='cursor-pointer' onClick={() => setEditKeyword(true)}/>
                <img src={DeleteIcn} onClick={() => deleteAction(updateItem)} alt='save_keyword' className='cursor-pointer' />
              </span>
            ) : null}
          </section>
          :
          <section className='d-flex align-item-center w-100'>
            <div className={`position-relative mx-3 mast_srch_sav w-84per ${updateMasterSearch?.loading ? 'disabled' : ''}`}>
              <Input values={updateItem?.name} onChangeCallback={(event) => setSaveItem({
                ...updateItem,
                name: formatZeroIndexCharAsCapitalize(event.target.value)
              })} />
              <img src={SaveIcn} alt='save' className={`cursor-pointer save_srch ${updateItem?.name?.length == 0 ? 'disabled' : ''}`} onClick={() => {
                applyAction({
                  ...updateItem
                });
                if(updateItem?.name === savedItem?.name){
                  setEditKeyword(false);
                } else {
                  setEditKeyword(true);
                }
              }} />
            </div>
            <img src={CloseIcn} alt='save_keyword' className='cursor-pointer save_srch wid-25' onClick={() => {
              setEditKeyword(false)
            }} />
          </section>}
        </>
      ) : (
        <section className='d-flex flex-column gap-10 w-100'>
          <section className='d-flex align-item-center gap-10 w-100'>
            <div className='m-3 w-100'>
              <Input classes="w-100" values={saveText} onChangeCallback={(event) => setSaveText(formatZeroIndexCharAsCapitalize(event.target.value))} />
              <section className='d-flex justify-content-end gap-10 mt-3 w-100'>
              { !isExecutive(selectedProfile?.accessLevel) && <button
                  type='button'
                  className='rounded-4 f-13 py-2 px-3 py-btn f-w-500 cursor-pointer master-search-share-btn'
                  disabled={saveText.length == 0 || createMasterSearch?.loading}
                  onClick={() => {
                    if(saveText.length > 0) {
                      setLoadingAction('share');
                      applyAction(true);
                    }
                  }}
                 >
                  {createMasterSearch?.loading && loadingAction === 'share' ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                      Save and Share
                    </>
                  ) : 'Save and Share'}
                </button>}
                <button
                  type='button'
                  className='rounded-4 f-13 py-2 px-3 py-btn f-w-500 cursor-pointer text-white master-search-save-btn'
                  disabled={saveText.length == 0 || createMasterSearch?.loading}
                  onClick={() => {
                    if(saveText.length > 0) {
                      setLoadingAction('save');
                      applyAction();
                    }
                  }}
                >
                  {createMasterSearch?.loading && loadingAction === 'save' ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                      Save
                    </>
                  ) : 'Save'}
                </button>
              </section>
            </div>
          </section>
        </section>
      )}
    </section>
  );
}
